import React, { useState, useRef, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import superagent from 'superagent';
import { AppTopbarUser } from './app-topbar-user';
import { Z_INDEX } from '../layout/app-sidebar/constants';
import { buildAdminUrl } from '../../utils/adminUrl';
import './topbar-user.css';

interface User {
  email: string;
}

interface AppTopbarUserMenuProps {
  user?: User;
  className?: string;
  tenantId?: string;
}

export function AppTopbarUserMenu({
  user,
  className,
  tenantId,
}: AppTopbarUserMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const history = useHistory();
  const { tenant } = useParams<{ tenant: string }>();
  const tenantNumber = tenant ? Number(tenant) : null;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        triggerRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        !triggerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const performLogout = async () => {
    try {
      await superagent.post('/api/logout');
    } catch (error) {
      console.error('Logout API call failed:', error);
    }
    history.push('/');
  };

  if (!user) return null;

  const triggerClass = ['topbar-user-trigger', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div style={{ position: 'relative' }}>
      <button
        ref={triggerRef}
        className={triggerClass}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Account"
      >
        <AppTopbarUser />
      </button>
      {isOpen && (
        <div
          ref={menuRef}
          className="topbar-menu"
          style={{ zIndex: Z_INDEX.DROPDOWN_MENU }}
        >
          <div className="topbar-menu__label">My Account</div>
          <div className="topbar-menu__separator" />
          {tenantId && tenantNumber && (
            <>
              <div
                className="topbar-menu__item"
                onClick={() => {
                  setIsOpen(false);
                  window.location.href = buildAdminUrl(
                    tenantNumber,
                    '/settings/profile'
                  );
                }}
              >
                Profile
              </div>
              <div className="topbar-menu__separator" />
            </>
          )}
          <div
            className="topbar-menu__item topbar-menu__item--danger"
            onClick={performLogout}
          >
            Log out
          </div>
        </div>
      )}
    </div>
  );
}
